/**
 * The controls, as the settings panel's Hotkeys list (and a HUD key legend)
 * show them: one row per action, grouped. The handlers live in
 * components/game/app/useHotkeys.ts, usePointerOrders.ts, useBoxSelect.ts and
 * StrategyCamera.tsx; a new binding there gets a row here. Pure, no React.
 */

export interface Hotkey {
  /** Each a key or chord, as shown on a key cap ("Ctrl+1–9"). */
  keys: readonly string[];
  action: string;
}

export interface HotkeyGroup {
  title: string;
  keys: readonly Hotkey[];
}

export const HOTKEYS: readonly HotkeyGroup[] = [
  {
    title: 'Camera',
    keys: [
      { keys: ['WASD', 'Arrows'], action: 'Pan' },
      { keys: ['Right-drag'], action: 'Pan by dragging the ground' },
      { keys: ['Wheel'], action: 'Zoom towards the cursor' },
    ],
  },
  {
    title: 'Selection',
    keys: [
      { keys: ['Click'], action: 'Select a unit, building or city' },
      { keys: ['Shift+click'], action: 'Add to or remove from the selection' },
      { keys: ['Drag'], action: 'Box-select' },
      { keys: ['1–9'], action: 'Select a control group (twice: go there; Shift adds)' },
      { keys: ['Ctrl+1–9'], action: 'Store the selection as a control group' },
      { keys: ['.'], action: 'Next idle worker' },
      { keys: ['F2'], action: 'Rename the selection' },
      { keys: ['Esc'], action: 'Back out: cancel, close, deselect' },
    ],
  },
  {
    title: 'Orders',
    keys: [
      { keys: ['Right-click'], action: 'Move, attack or work there' },
      { keys: ['Shift+right-click'], action: 'Queue a focus target' },
      { keys: ['Backspace'], action: 'Drop the last queued focus target' },
      { keys: ['A'], action: 'Attack-move' },
      { keys: ['H'], action: 'Hold position' },
      { keys: ['G'], action: 'Group the selection into a formation' },
      { keys: ['U'], action: 'Ungroup' },
    ],
  },
  {
    title: 'Panels',
    keys: [
      { keys: ['E'], action: 'Empire list (units, buildings, workers)' },
      { keys: ['Y'], action: 'Upgrades' },
      { keys: ['?'], action: 'This key list, over the map' },
    ],
  },
];
